module.exports = __webpack_public_path__ + "d2f28e4240502133aeada2a71f0524e3.png";